import { useDispatch, useSelector } from 'react-redux';
import { showLoading, hideLoading } from '../store/slices/loading/loadingSlice';
import { RootState } from '../store/store';

const useLoading = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.loading.isLoading);

  const showLoadingIndicator = () => dispatch(showLoading());
  const hideLoadingIndicator = () => dispatch(hideLoading());

  return { isLoading, showLoadingIndicator, hideLoadingIndicator };
};

export default useLoading;